module.exports = __webpack_public_path__ + "static/media/lending-tools3.67d16fb2.svg";